<h2 mat-dialog-title class="mat-title">
    {{'COMPANY_BRANCHES.closedbranch_dialog-title'|translate}}
    <span (click)="closeDialog()" class="close-dialog">
    <mat-icon>close</mat-icon></span>
  </h2>
  <mat-dialog-content class="dialog-info">
      <div >
   {{content|translate}}
  </div>
  </mat-dialog-content>
  
  <mat-dialog-actions >
      <button color="primary" mat-raised-button (click)="closeDialog()">Proceed</button>
    </mat-dialog-actions>
  